import React from 'react';
import { t } from 'es6/services/localization';
import { requestPhonePasswordReset } from 'es6/core/paths';
import AuthenticationForm from 'es6/containers/registration/authentication-box/authentication-form';
import FlashMessages from 'es6/containers/common/flash-messages';
import BrandButton from 'es6/containers/common/buttons/brand-button';
import CsrfTokenInput from 'es6/containers/registration/inputs/csrf-token';
import InputContainer from 'es6/components/registration/authentication-box/input-container';
import CountryCodePhoneInput from 'es6/containers/registration/inputs/country-code-phone';

function PhoneForgotPasswordForm() {
  return (
    <AuthenticationForm isInline action={requestPhonePasswordReset()} delay>
      <FlashMessages />
      <CsrfTokenInput />

      <InputContainer>
        <CountryCodePhoneInput
          name="user_phone_number"
        />
      </InputContainer>

      <InputContainer>
        <BrandButton type="submit">
          {t('confirm-your-phone.submit')}
        </BrandButton>
      </InputContainer>
    </AuthenticationForm>
  );
}


export default PhoneForgotPasswordForm;
